import React from "react";

export default (props) => (
  <svg {...props} viewBox="0 0 30 28">
    <path d="M 30 2.5L 0 2.5L 0 0L 30 0L 30 2.5ZM 30 6.25L 0 6.25L 0 8.75L 30 8.75L 30 6.25ZM 30 12.5L 0 12.5L 0 15L 30 15L 30 12.5ZM 30 18.75L 0 18.75L 0 21.25L 30 21.25L 30 18.75ZM 30 25L 0 25L 0 27.5L 30 27.5L 30 25Z" />
  </svg>
);
